import axiosHttp from '@/utilities/axios-http'
import apiConfig from '@/config/api-config'
import authConfig from '@/config/auth-config'

class AuthService {
  checkAuth = () => {
    const authToken = localStorage.getItem(authConfig.AUTH_TOKEN_KEY)

    if (authToken) {
      axiosHttp.defaults.headers.common[
        'Authorization'
      ] = `${authConfig.AUTH_TOKEN_TYPE} ${authToken}`

      return new Promise((resolve, reject) => {
        axiosHttp
          .get(
            `/${apiConfig.API_PATH}/${authConfig.AUTH_PATH}/${authConfig.USER_PATH}`
          )
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            localStorage.removeItem(authConfig.AUTH_TOKEN_KEY)
            delete axiosHttp.defaults.headers.common['Authorization']

            reject(error)
          })
      })
    } else {
      return Promise.resolve()
    }
  }

  login = payload => {
    localStorage.removeItem(authConfig.AUTH_TOKEN_KEY)
    delete axiosHttp.defaults.headers.common['Authorization']

    return new Promise((resolve, reject) => {
      axiosHttp
        .post(
          `/${apiConfig.API_PATH}/${authConfig.AUTH_PATH}/${authConfig.LOGIN_PATH}`,
          payload
        )
        .then(response => {
          const authToken = response.headers['auth-token']

          localStorage.setItem(authConfig.AUTH_TOKEN_KEY, authToken)

          axiosHttp.defaults.headers.common[
            'Authorization'
          ] = `${authConfig.AUTH_TOKEN_TYPE} ${authToken}`

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  logout = () => {
    return new Promise((resolve, reject) => {
      axiosHttp
        .get(
          `/${apiConfig.API_PATH}/${authConfig.AUTH_PATH}/${authConfig.LOGOUT_PATH}`
        )
        .then(response => {
          localStorage.removeItem(authConfig.AUTH_TOKEN_KEY)
          delete axiosHttp.defaults.headers.common['Authorization']

          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new AuthService()
